<div class="relative -mt-7 mb-7">
  <aux-route-tab-group [tabs]="tabs" [indexFn]="indexFn" />
</div>

<router-outlet />
